import { DailyParticipant } from '@daily-co/daily-js';

type Props = {
  participants: DailyParticipant[];
};

export const VideoGrid = ({ participants }: Props) => (
  <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
    {participants.map((participant) => (
      <div key={participant.session_id} className="relative rounded-xl border border-background-border bg-background-surface/50 p-4">
        <video
          autoPlay
          playsInline
          muted={participant.local}
          ref={(element) => {
            if (!element) return;
            const track = participant.tracks.video;
            if (track?.state === 'playable' && track.persistentTrack) {
              element.srcObject = new MediaStream([track.persistentTrack]);
            }
          }}
          className="aspect-video w-full rounded-lg bg-black object-cover"
        />
        <div className="mt-2 flex items-center justify-between text-sm text-text-primary">
          <span>{participant.user_name ?? 'Participant'}</span>
          <span className="text-xs text-text-dimmed">{participant.local ? 'You' : 'Live'}</span>
        </div>
      </div>
    ))}
  </div>
);

